import React, { useEffect, useRef, useState } from 'react'
import { Column } from 'primereact/column'
import EstadoCivilService from "./estadoCivilService"
import FormList from 'base/FormList'

export default function EstadoCivilList() {

    const [service] = useState(() => new EstadoCivilService())
    const toast = useRef(null)
    const searchData = {
        pkName: 'codigo_esci',
        dsName: 'descricao_esci',
        mainField: { name: 'descricao_esci', label: 'Descrição' },
        advFields: [
            { name: 'codigo_esci', label: 'Código', type: 'integer', inputMode: 'numeric' },
            { name: 'descricao_esci', label: 'Descrição', type: 'string', inputMode: 'text' },
        ]
    }

    useEffect(() => {
    }, [service])

    return (
        <FormList service={service} toast={toast} searchData={searchData} showActions={true}>
            <Column field="descricao_esci" sortable header="Descrição"></Column>
        </FormList >
    )
}
